// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14 2H2V22H16V16H18V22H22V10H14V2ZM12 10H9V8H12V10ZM12 20H4V16H12V20ZM12 14H9V12H12V14ZM7 8V10H4V8H7ZM4 14V12H7V14H4ZM7 6H4V4H7V6ZM9 6V4H12V6H9Z"}}]};

const City8FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-8-filled',
    ref,
    icon: element,
  },
));

City8FilledIcon.displayName = 'City8FilledIcon';

export default City8FilledIcon;
